const colorNameToHex = {
   amber: '#ffbf00',
   artic_white: '#ffffff',
   beige: '#f5f5dc',
   black: '#000000',
   blue: '#31639c',
   blue_ice: '#31639c',
   brilliant_white: '#ffffff',
   bronze: '#9c5221',
   brown: '#a37063',
   cash_register_white: '#ffffff',
   clear: '#ffffff',
   clear_blue: '#31639c',
   crystal_clear: '#ffffff',
   crystal_oxidised: '#ffffff',
   cyan: '#2cb7b9',
   gold: '#E7BD42',
   green: '#49B675',
   greige: '#EDEEE8',
   grey: '#909090',
   ivory: '#F2E7BF',
   light: '#ffffff',
   light_blue: '#C3E4E8',
   metallic: '#738184',
   mixed_colors: '#ffffff',
   natural: '#ffffff',
   natural_black: '#000000',
   natural_oxidised: '#ffffff',
   natural_white: '#ffffff',
   opal: '#A8C3BC',
   orange: '#FC9303',
   pink: '#FFAAAA',
   purple: '#5A005A',
   red: '#C4342d',
   seperate: '#ffffff',
   silver: '#b5b5bd',
   stone_effect: '#ffffff',
   stryker_effect: '#ffffff',
   terracotta: '#d07c50',
   translucent: '#E5E6D1',
   transparent: '#ffffff',
   turquoise: '#006B5A',
   twilight_black: '#000000',
   violet: '#D2A8D4',
   violet_trans: '#D2A8D4',
   white: '#ffffff',
   water_white: '#F3f0e0',
   white_trans: '#ffffff',
   wild_rice: '#64550',
   yellow: '#FCE903'
};

const inaccessibleColors = [
   'artic_white',
   'beige',
   'brilliant_white',
   'brown',
   'cash_register_white',
   'clear',
   'crystal_clear',
   'crystal_oxidised',
   'cyan',
   'greige',
   'ivory',
   'light',
   'light_blue',
   'mixed_colors',
   'natural',
   'natural_oxidised',
   'natural_white',
   'opal',
   'seperate',
   'silver',
   'stone_effect',
   'stryker_effect',
   'translucent',
   'transparent',
   'violet',
   'violet_trans',
   'water_white',
   'white',
   'white_trans'
];

interface Props {
   colorName: string | undefined;
}

const StrokedIcon = () => (
   <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
      <path
         data-testid="stroked-icon"
         fill="#000"
         d="M10.469 15.852a1 1 0 0 1 .286 1.977l-.43.074a9.059 9.059 0 0 1-2.65 0l-.43-.074-.1-.025a1 1 0 0 1 .386-1.952l.102.015.334.058a7.072 7.072 0 0 0 2.4-.058l.102-.015Zm-7.29-2.963A7.044 7.044 0 0 0 5.11 14.82 1 1 0 0 1 4 16.483a9.046 9.046 0 0 1-2.482-2.482l1.662-1.112ZM14 16.483a1 1 0 1 1-1.112-1.662L14 16.483Zm.82-3.594A1 1 0 0 1 16.483 14a9.046 9.046 0 0 1-2.482 2.482l-1.112-1.662a7.045 7.045 0 0 0 1.932-1.932Zm-13.03-.275a1 1 0 0 1 1.388.275L1.517 14a1 1 0 0 1 .274-1.387ZM0 9c0-.6.058-1.187.17-1.755l.026-.1a1 1 0 0 1 1.937.488l-.058.334a7.065 7.065 0 0 0 0 2.066l.058.334.015.102a1 1 0 0 1-1.952.386l-.025-.1-.074-.43A9.066 9.066 0 0 1 0 9Zm16 0c0-.352-.025-.697-.075-1.033l-.058-.334-.015-.102a1 1 0 0 1 1.952-.385l.025.1.074.429a9.059 9.059 0 0 1-.074 3.08l-.025.1a1 1 0 0 1-1.937-.488l.058-.334C15.975 9.697 16 9.352 16 9ZM3.179 5.111A1 1 0 0 1 1.517 4l1.662 1.112Zm9.435-3.32a1 1 0 0 1 1.387-.274 9.046 9.046 0 0 1 2.482 2.482 1 1 0 1 1-1.662 1.112A7.044 7.044 0 0 0 12.89 3.18a1 1 0 0 1-.275-1.388ZM4 1.517a1 1 0 1 1 1.112 1.662A7.043 7.043 0 0 0 3.18 5.11L1.517 4a9.045 9.045 0 0 1 2.482-2.482ZM9 0c.45 0 .892.033 1.325.097l.43.074.1.025a1 1 0 0 1-.386 1.952l-.102-.015-.334-.058a7.065 7.065 0 0 0-2.4.058l-.102.015A1 1 0 0 1 7.245.171l.43-.074A9.066 9.066 0 0 1 9 0Z"
      />
   </svg>
);

const OutlineFilledIcon = ({ color }: { color: string }) => (
   <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
      <circle data-testid="outline-filled-icon" cx={9} cy={9} r={8} fill={color} stroke="#000" strokeWidth={2} />
   </svg>
);

const FilledIcon = ({ color }: { color: string }) => (
   <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
      <path data-testid="filled-icon" fill={color} d="M18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0Z" />
   </svg>
);

export const ColorIcon = ({ colorName }: Props) => {
   if (!colorName || colorName === 'natural') {
      return <OutlineFilledIcon color="#fff" />;
   }

   if (colorName === 'other') {
      return <StrokedIcon />;
   }

   const hexColor = colorName in colorNameToHex ? colorNameToHex[colorName as keyof typeof ColorIcon] : undefined;
   if (hexColor) {
      if (inaccessibleColors.includes(colorName)) return <OutlineFilledIcon color={hexColor} />;
      return <FilledIcon color={hexColor} />;
   }

   return <OutlineFilledIcon color="#fff" />;
};
